import { createMigrate } from 'redux-persist';

export const persistStoreMigrate = createMigrate({
  1: state => state,
});

export const version = 1;
